import { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";

export const useToken = () => {
    const [token, setToken] = useState('');

    useEffect(() => {
        setToken(getToken());

    }, []);

    const getToken = () => {
        const userToken = sessionStorage.getItem('token');
        return userToken ? userToken : null;
    };

    const decodeToken = (jwtToken) => {
        return jwt_decode(jwtToken);
    }

    const getUserName = () => {
        const decodedToken = decodeToken(getToken());
        return decodedToken ? decodedToken.Username : null;
    }


    const getUserEmail = () => {
        const decodedToken = decodeToken(getToken());
        return decodedToken ? decodedToken.Email : null;
    }


    const getUserType = () => {
        const decodedToken = decodeToken(getToken());
        return decodedToken ? decodedToken.UserType : null;
    }

    const getUserCompanyId = () => {
        const decodedToken = decodeToken(getToken());
        return decodedToken ? decodedToken.CompanyId : null;
    }

    const getExp = () => {
        const decodedToken = decodeToken(getToken());
        return decodedToken ? decodedToken.exp : null;
    }

    const saveToken = userToken => {
        sessionStorage.setItem('token', userToken);
        setToken(userToken);
    }

    const removeToken = () => {
        sessionStorage.setItem('token', null);
        setToken(null);
    }

    const getTypesOperations = () => {
        const decodedToken = decodeToken(getToken());
        return decodedToken ? decodedToken.TypesOperations : null;
    }

    const getUserCompanyName = () => {
        const decodedToken = decodeToken(getToken());
        return decodedToken ? decodedToken.CompanyName : null;
    }

    const hasToken = () => {
        const token = getToken();
        return token !== null && token !== 'null' && token !== '';
    }



    return [
        token,
        {
            token,
            hasToken,
            saveToken,
            removeToken,
            getUserName,
            getUserEmail,
            getUserType,
            getUserCompanyId,
            getExp,
            getTypesOperations,
            getUserCompanyName,
        }
    ]
}